export class YukiCredential {
    key: string;
    name: string;
}
